import { Component, OnInit,Input } from '@angular/core';
import { VoiceBatchService } from '../../../service/voice/voice-batch.service';
import { CallEvents }  from '../../../model/call-events'

@Component({
  selector: 'app-call-history',
  templateUrl: './call-history.component.html',
  styleUrls: ['./call-history.component.scss']
})
export class CallHistoryComponent implements OnInit {

  @Input() batch_detail_id:string;
  public callHistory:CallEvents[] = []
  loading:Boolean = false;

  constructor(private http:VoiceBatchService) { }

  ngOnInit() {
    this.loading = true;
    this.http.getCallHistory(this.batch_detail_id).subscribe(
      (data) => this.callHistory = <CallEvents[]>(data),
      (err) => alert('Error fetching call history'),
      () => this.loading = false
    )

  }

}
